import { createContext, useContext, useState, useCallback, useEffect } from 'react';

const LanguageContext = createContext();

const defaultTranslations = {
  ca: {
    // Navigation
    nav: {
      elCamp: 'El Camp',
      jugar: 'Jugar',
      competicio: 'Competició',
      iniciacio: 'Acadèmia',
      drivingRange: 'Pràctiques',
      restaurant: 'Restaurant',
      allotjament: 'Allotjament',
      correspondencies: 'Correspondències',
      contacte: 'Contacte',
      equip: "L'equip",
      premsa: 'Premsa',
      areaMembres: 'Àrea Membres',
      reserva: 'Reserva'
    },
    // Home
    home: {
      heroTitle: 'Golf als Pirineus',
      heroSubtitle: 'Descobreix UGOLF ARAVELL Andorra, una experiència única als Pirineus',
      ctaProva: 'Prova el Golf',
      ctaAbonat: 'Abonat',
      ctaOfertes: 'Ofertes',
      ctaLeClub: 'Fes-te de LeClub',
      ctaTorneig: "Inscriu-te a un torneig",
      ctaActivitats: 'Activitats'
    },
    // Footer
    footer: {
      avisLegal: 'Avís legal',
      politicaPrivacitat: 'Política de privacitat',
      politicaCookies: 'Política de cookies',
      configuracioCookes: 'Configuració cookies',
      drets: 'Tots els drets reservats'
    },
    // Contact
    contact: {
      title: 'Contacte',
      subtitle: "Estem aquí per ajudar-te",
      nom: 'Nom',
      email: 'Correu electrònic',
      telefon: 'Telèfon',
      assumpte: 'Assumpte',
      missatge: 'Missatge',
      accepto: "Accepto la política de privacitat",
      enviar: 'Enviar',
      enviament: 'Enviant...',
      gracies: 'Gràcies pel teu missatge!',
      error: "Hi ha hagut un error. Si us plau, intenta-ho de nou."
    },
    // Common
    common: {
      veureMes: 'Veure més',
      tornar: 'Tornar',
      carregant: 'Carregant...'
    },
    // El Camp
    elCamp: {
      title: 'El Camp',
      subtitle: 'Un camp únic als Pirineus',
      foratAForat: 'Forat a Forat',
      forat: 'Forat',
      par: 'Par',
      metres: 'metres',
      hcp: 'HCP'
    },
    // Competition
    competicio: {
      title: 'Competició',
      subtitle: 'Calendari de torneigs i competicions',
      passats: 'Torneigs Passats',
      futurs: 'Torneigs Futurs',
      calendari: 'Calendari'
    },
    // Members
    membres: {
      title: 'Àrea Membres',
      subtitle: 'Accedeix a la teva àrea personal',
      accedir: 'Accedir a Àrea Membres'
    },
    // Anyós Park
    anyos: {
      // Landing page
      jaJugues: 'Ja jugues a golf?',
      jaJuguesText: "Si ets jugador de golf i soci d'Anyós Park El Club vine a UGOLF ARAVELL Andorra i gaudeix d'un preu especial.",
      reserva: 'RESERVA',
      codiText: "Introdueix el codi que et facilita Anyós Park a la seva graella d'activitats.",
      pagamentText: "Paga el teu greenfee al arribar al camp, recorda presentar el teu document que t'acredita com a soci d'Anyós Park El Club junt al teu document d'identitat.",
      volsDescobrir: 'Vols descobrir el golf?',
      volsDescobrirText: "Si ets soci d'Anyós Park El Club tens la oportunitat de descobrir el golf a un preu especial i junt a altres socis.",
      comencaSessio: 'Comença per la sessió d\'iniciació de',
      hores: 'hores',
      donaPrimerCop: 'Dona el primer cop!',
      // Funnel page
      viuExperiencia: "Viu l'experiència del golf amb una sessió completa d'iniciació de 3 hores",
      descobreixGolf: 'Descobreix el Golf amb el grup especial Anyós Park',
      diumenges10h: 'Diumenges 10h',
      queInclou: 'Què inclou la sessió?',
      experienciaCompleta: 'Una experiència completa de 3 hores',
      tourCamp: 'Tour pel camp',
      introduccioJoc: 'Introducció al joc',
      putt: 'Putt',
      jocLlarg: 'Joc llarg',
      jugarForat: 'Jugar un forat',
      buggyVideo: 'Buggy vídeo',
      repteFinal: 'Repte final',
      preus: 'Preus',
      publicGeneral: 'Públic general',
      socisAnyos: 'Socis Anyós Park',
      descompte: 'DESCOMPTE',
      estalvia: 'Estalvia',
      pagamentCamp: 'Pagament al camp el dia de la sessió',
      reservaPlaça: 'Reserva la teva plaça',
      sessionsGrup: 'Sessions en grup els diumenges a les 10h',
      places: 'places',
      complet: 'COMPLET',
      inscripcio: 'Inscripció per al',
      nomCognoms: 'Nom i cognoms',
      telefon: 'Telèfon',
      email: 'Email',
      socAnyosPark: "Sóc soci d'Anyós Park",
      marcaCasella: 'Marca aquesta casella per aplicar el preu especial de 40€',
      acceptoPolitica: 'Accepto la',
      politicaPrivacitat: 'política de privacitat',
      tractamentDades: 'i el tractament de les meves dades',
      confirmarInscripcio: 'Confirmar Inscripció',
      oBe: 'o bé',
      sollicitarPrivada: 'Sol·licitar sessió privada',
      disponibilitat: 'Disponibilitat / Comentaris',
      indicaDisponibilitat: "Indica'ns quines dates i hores et podrien anar bé...",
      enviarSollicitud: 'Enviar Sol·licitud',
      inscripcioConfirmada: 'Inscripció Confirmada!',
      sollicitudEnviada: 'Sol·licitud Enviada!',
      emailConfirmacio: "T'hem enviat un email amb tots els detalls de la teva reserva. Ens veiem al camp!",
      contactarem: "Hem rebut la teva sol·licitud. Ens posarem en contacte amb tu molt aviat per confirmar la data i hora.",
      recordatori: 'Recordatori',
      pagamentDia: 'El pagament es realitza al camp el dia de la sessió.',
      tornarInici: "Tornar a l'inici",
      onSom: 'On som?'
    }
  },
  es: {
    nav: {
      elCamp: 'El Campo',
      jugar: 'Jugar',
      competicio: 'Competición',
      iniciacio: 'Academia',
      drivingRange: 'Prácticas',
      restaurant: 'Restaurante',
      allotjament: 'Alojamiento',
      correspondencies: 'Correspondencias',
      contacte: 'Contacto',
      equip: 'El equipo',
      premsa: 'Prensa',
      areaMembres: 'Área Miembros',
      reserva: 'Reserva'
    },
    home: {
      heroTitle: 'Golf en los Pirineos',
      heroSubtitle: 'Descubre UGOLF ARAVELL Andorra, una experiencia única en los Pirineos',
      ctaProva: 'Prueba el Golf',
      ctaAbonat: 'Abonado',
      ctaOfertes: 'Ofertas',
      ctaLeClub: 'Hazte de LeClub',
      ctaTorneig: 'Inscríbete a un torneo',
      ctaActivitats: 'Actividades'
    },
    footer: {
      avisLegal: 'Aviso legal',
      politicaPrivacitat: 'Política de privacidad',
      politicaCookies: 'Política de cookies',
      configuracioCookes: 'Configuración cookies',
      drets: 'Todos los derechos reservados'
    },
    contact: {
      title: 'Contacto',
      subtitle: 'Estamos aquí para ayudarte',
      nom: 'Nombre',
      email: 'Correo electrónico',
      telefon: 'Teléfono',
      assumpte: 'Asunto',
      missatge: 'Mensaje',
      accepto: 'Acepto la política de privacidad',
      enviar: 'Enviar',
      enviament: 'Enviando...',
      gracies: '¡Gracias por tu mensaje!',
      error: 'Ha habido un error. Por favor, inténtalo de nuevo.'
    },
    common: {
      veureMes: 'Ver más',
      tornar: 'Volver',
      carregant: 'Cargando...'
    },
    elCamp: {
      title: 'El Campo',
      subtitle: 'Un campo único en los Pirineos',
      foratAForat: 'Hoyo a Hoyo',
      forat: 'Hoyo',
      par: 'Par',
      metres: 'metros',
      hcp: 'HCP'
    },
    competicio: {
      title: 'Competición',
      subtitle: 'Calendario de torneos y competiciones',
      passats: 'Torneos Pasados',
      futurs: 'Torneos Futuros',
      calendari: 'Calendario'
    },
    membres: {
      title: 'Área Miembros',
      subtitle: 'Accede a tu área personal',
      accedir: 'Acceder a Área Miembros'
    },
    anyos: {
      jaJugues: '¿Ya juegas a golf?',
      jaJuguesText: 'Si eres jugador de golf y socio de Anyós Park El Club ven a UGOLF ARAVELL Andorra y disfruta de un precio especial.',
      reserva: 'RESERVA',
      codiText: 'Introduce el código que te facilita Anyós Park en su parrilla de actividades.',
      pagamentText: 'Paga tu greenfee al llegar al campo, recuerda presentar tu documento que te acredita como socio de Anyós Park El Club junto a tu documento de identidad.',
      volsDescobrir: '¿Quieres descubrir el golf?',
      volsDescobrirText: 'Si eres socio de Anyós Park El Club tienes la oportunidad de descubrir el golf a un precio especial y junto a otros socios.',
      comencaSessio: 'Empieza por la sesión de iniciación de',
      hores: 'horas',
      donaPrimerCop: '¡Da el primer golpe!',
      viuExperiencia: 'Vive la experiencia del golf con una sesión completa de iniciación de 3 horas',
      descobreixGolf: 'Descubre el Golf con el Grupo especial Anyós Park',
      diumenges10h: 'Domingos 10h',
      queInclou: '¿Qué incluye la sesión?',
      experienciaCompleta: 'Una experiencia completa de 3 horas',
      tourCamp: 'Tour por el campo',
      introduccioJoc: 'Introducción al juego',
      putt: 'Putt',
      jocLlarg: 'Juego largo',
      jugarForat: 'Jugar un hoyo',
      buggyVideo: 'Buggy vídeo',
      repteFinal: 'Reto final',
      preus: 'Precios',
      publicGeneral: 'Público general',
      socisAnyos: 'Socios Anyós Park',
      descompte: 'DESCUENTO',
      estalvia: 'Ahorra',
      pagamentCamp: 'Pago en el campo el día de la sesión',
      reservaPlaça: 'Reserva tu plaza',
      sessionsGrup: 'Sesiones en grupo los domingos a las 10h',
      places: 'plazas',
      complet: 'COMPLETO',
      inscripcio: 'Inscripción para el',
      nomCognoms: 'Nombre y apellidos',
      telefon: 'Teléfono',
      email: 'Email',
      socAnyosPark: 'Soy socio de Anyós Park',
      marcaCasella: 'Marca esta casilla para aplicar el precio especial de 40€',
      acceptoPolitica: 'Acepto la',
      politicaPrivacitat: 'política de privacidad',
      tractamentDades: 'y el tratamiento de mis datos',
      confirmarInscripcio: 'Confirmar Inscripción',
      oBe: 'o bien',
      sollicitarPrivada: 'Solicitar sesión privada',
      disponibilitat: 'Disponibilidad / Comentarios',
      indicaDisponibilitat: 'Indícanos qué fechas y horas te podrían ir bien...',
      enviarSollicitud: 'Enviar Solicitud',
      inscripcioConfirmada: '¡Inscripción Confirmada!',
      sollicitudEnviada: '¡Solicitud Enviada!',
      emailConfirmacio: 'Te hemos enviado un email con todos los detalles de tu reserva. ¡Nos vemos en el campo!',
      contactarem: 'Hemos recibido tu solicitud. Nos pondremos en contacto contigo muy pronto para confirmar la fecha y hora.',
      recordatori: 'Recordatorio',
      pagamentDia: 'El pago se realiza en el campo el día de la sesión.',
      tornarInici: 'Volver al inicio',
      onSom: '¿Dónde estamos?'
    }
  },
  fr: {
    nav: {
      elCamp: 'Le Parcours',
      jugar: 'Jouer',
      competicio: 'Compétition',
      iniciacio: 'Académie',
      drivingRange: 'Practice',
      restaurant: 'Restaurant',
      allotjament: 'Hébergement',
      correspondencies: 'Correspondances',
      contacte: 'Contact',
      equip: "L'équipe",
      premsa: 'Presse',
      areaMembres: 'Espace Membres',
      reserva: 'Réserver'
    },
    home: {
      heroTitle: 'Golf dans les Pyrénées',
      heroSubtitle: 'Découvrez UGOLF ARAVELL Andorra, une expérience unique dans les Pyrénées',
      ctaProva: 'Essayer le Golf',
      ctaAbonat: 'Abonné',
      ctaOfertes: 'Offres',
      ctaLeClub: 'Rejoignez LeClub',
      ctaTorneig: "S'inscrire à un tournoi",
      ctaActivitats: 'Activités'
    },
    footer: {
      avisLegal: 'Mentions légales',
      politicaPrivacitat: 'Politique de confidentialité',
      politicaCookies: 'Politique de cookies',
      configuracioCookes: 'Configuration cookies',
      drets: 'Tous droits réservés'
    },
    contact: {
      title: 'Contact',
      subtitle: 'Nous sommes là pour vous aider',
      nom: 'Nom',
      email: 'E-mail',
      telefon: 'Téléphone',
      assumpte: 'Sujet',
      missatge: 'Message',
      accepto: "J'accepte la politique de confidentialité",
      enviar: 'Envoyer',
      enviament: 'Envoi en cours...',
      gracies: 'Merci pour votre message !',
      error: 'Une erreur est survenue. Veuillez réessayer.'
    },
    common: {
      veureMes: 'Voir plus',
      tornar: 'Retour',
      carregant: 'Chargement...'
    },
    elCamp: {
      title: 'Le Parcours',
      subtitle: 'Un parcours unique dans les Pyrénées',
      foratAForat: 'Trou par Trou',
      forat: 'Trou',
      par: 'Par',
      metres: 'mètres',
      hcp: 'HCP'
    },
    competicio: {
      title: 'Compétition',
      subtitle: 'Calendrier des tournois et compétitions',
      passats: 'Tournois Passés',
      futurs: 'Tournois Futurs',
      calendari: 'Calendrier'
    },
    membres: {
      title: 'Espace Membres',
      subtitle: 'Accédez à votre espace personnel',
      accedir: "Accéder à l'Espace Membres"
    }
  },
  en: {
    nav: {
      elCamp: 'The Course',
      jugar: 'Play',
      competicio: 'Competition',
      iniciacio: 'Academy',
      drivingRange: 'Practice',
      restaurant: 'Restaurant',
      allotjament: 'Accommodation',
      correspondencies: 'Reciprocal',
      contacte: 'Contact',
      equip: 'The Team',
      premsa: 'Press',
      areaMembres: 'Members Area',
      reserva: 'Book Now'
    },
    home: {
      heroTitle: 'Golf in the Pyrenees',
      heroSubtitle: 'Discover UGOLF ARAVELL Andorra, a unique experience in the Pyrenees',
      ctaProva: 'Try Golf',
      ctaAbonat: 'Membership',
      ctaOfertes: 'Offers',
      ctaLeClub: 'Join LeClub',
      ctaTorneig: 'Sign up for a tournament',
      ctaActivitats: 'Activities'
    },
    footer: {
      avisLegal: 'Legal Notice',
      politicaPrivacitat: 'Privacy Policy',
      politicaCookies: 'Cookie Policy',
      configuracioCookes: 'Cookie Settings',
      drets: 'All rights reserved'
    },
    contact: {
      title: 'Contact',
      subtitle: 'We are here to help',
      nom: 'Name',
      email: 'Email',
      telefon: 'Phone',
      assumpte: 'Subject',
      missatge: 'Message',
      accepto: 'I accept the privacy policy',
      enviar: 'Send',
      enviament: 'Sending...',
      gracies: 'Thank you for your message!',
      error: 'There was an error. Please try again.'
    },
    common: {
      veureMes: 'See more',
      tornar: 'Back',
      carregant: 'Loading...'
    },
    elCamp: {
      title: 'The Course',
      subtitle: 'A unique course in the Pyrenees',
      foratAForat: 'Hole by Hole',
      forat: 'Hole',
      par: 'Par',
      metres: 'meters',
      hcp: 'HCP'
    },
    competicio: {
      title: 'Competition',
      subtitle: 'Tournament and competition calendar',
      passats: 'Past Tournaments',
      futurs: 'Upcoming Tournaments',
      calendari: 'Calendar'
    },
    membres: {
      title: 'Members Area',
      subtitle: 'Access your personal area',
      accedir: 'Access Members Area'
    }
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('ca');
  const [translations, setTranslations] = useState(defaultTranslations);

  // Load language from URL or localStorage
  useEffect(() => {
    const pathLang = window.location.pathname.split('/')[1];
    const validLangs = ['ca', 'es', 'fr', 'en'];
    
    if (validLangs.includes(pathLang)) {
      setLanguage(pathLang);
    } else {
      const savedLang = localStorage.getItem('aravell-lang');
      if (savedLang && validLangs.includes(savedLang)) {
        setLanguage(savedLang);
      }
    }
  }, []);

  // Save language preference
  useEffect(() => {
    localStorage.setItem('aravell-lang', language);
  }, [language]);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key;
      }
    }
    
    return value || key;
  }, [language, translations]);

  const changeLanguage = useCallback((newLang) => {
    const validLangs = ['ca', 'es', 'fr', 'en'];
    if (validLangs.includes(newLang)) {
      setLanguage(newLang);
    }
  }, []);

  const updateTranslation = useCallback((lang, key, value) => {
    setTranslations(prev => {
      const newTranslations = { ...prev };
      const keys = key.split('.');
      let obj = newTranslations[lang];
      
      for (let i = 0; i < keys.length - 1; i++) {
        if (!obj[keys[i]]) obj[keys[i]] = {};
        obj = obj[keys[i]];
      }
      
      obj[keys[keys.length - 1]] = value;
      return newTranslations;
    });
  }, []);

  return (
    <LanguageContext.Provider value={{
      language,
      setLanguage: changeLanguage,
      t,
      translations,
      updateTranslation,
      availableLanguages: ['ca', 'es', 'fr', 'en']
    }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
